import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Package} from '~local/app/types/Package';
import {Observable} from 'rxjs';
import {BoughtPackage} from './../../types/BoughtPackage';
import {DataSourceResponse, DataSourceService} from './DataSourceService';

@Injectable()
export class PackageService extends DataSourceService<BoughtPackage> {
    constructor(private readonly http: HttpClient) {
        super();
    }

    public loadData(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10
    ): Observable<DataSourceResponse<BoughtPackage>> {
        return this.http.get<DataSourceResponse<BoughtPackage>>('/admin/packages/bought/list', {
            params: new HttpParams()
                .set('filter', filter)
                .set('orderBy', orderBy)
                .set('sort', orderDirection.toUpperCase())
                .set('skip', pageNumber.toString())
                .set('take', pageSize.toString())
        });
    }

    public getPackages(): Observable<any> {
        return this.http.get<Package[]>('/admin/packages/list');
    }

    public postPackage(data: any): Observable<any> {
        return this.http.post<any>('/admin/packages/', data);
    }
}
